import { useEffect } from 'react';
import { useChannelStateContext } from './streamHooks';

/**
 * This hook is workaround to mark currently selected channel as read while you viewing it.
 * Actually this should work under-the-hood, but looks like sometimes it does not work
 * https://fastcto.atlassian.net/browse/PROC-2773
 */
export const useMarkChannelAsRead = () => {
  const { channel } = useChannelStateContext();
  useEffect(() => {
    if (channel) {
      channel.markRead();
    }
  }, [channel]);
};
